export default {"src":"/_next/static/media/mainnet-color.aa0e9282.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};